import {
  SCREENMAKER_START,
  SCREENMAKER_DATA,
  SCREENMAKER_END,
} from "../../slices/type";

interface InitState {
  data: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const ScreenMaker_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case SCREENMAKER_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case SCREENMAKER_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
 
    case SCREENMAKER_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default ScreenMaker_Red;
